import timer from '@devices/settings/device_settings/timer.js';
import schedule from '@devices/settings/device_settings/schedule.js';
import night_mode from '@devices/settings/device_settings/night_mode.js';
import actions from '@devices/settings/device_settings/actions.js';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'shellycolorbulb',
	friendly_name: 'Color Bulb',
	family: 'light',
	isPM: true,
	modes: {
		color: {
			channels: 1,
			notifications: ['offline', 'device_problem', 'forgotten_lights'],
			color_temp: { minValue: 3000, maxValue: 6500 },
			color: true,
			slider: 'gain',
			gain: 0,
			effects: [
				{ label: 'OFF', id: 0 },
				{ label: 'METEOR SHOWER', id: 1 },
				{ label: 'GRADUAL CHANGE', id: 2 },
				{ label: 'FLASH', id: 3 },
			],
			settings: [
				timer,
				schedule,
				night_mode,
				actions,
				{
					title: 'networks',
					components: [
						{ title: 'wifi_mode_client', component: 'wifi_mode_client' },
						{ title: 'wifi_client_backup', component: 'wifi_client_backup' },
						{ title: 'wifi_mode_ap', component: 'wifi_mode_ap' },
						{ title: 'restrict_login', component: 'restrict_login' },
						{
							title: 'advanced_developer_settings',
							component: 'advanced_developer_settings',
						},
						{ title: 'cloud', component: 'cloud' },
					],
				},
				{
					title: 'application_settings',
					components: [
						{
							title: 'device_card_customization',
							component: 'customize_device_content',
						},
						{
							title: 'consumption_calculation',
							component: 'consumption_calculation',
						},
						{
							title: 'consumption_hierarchy',
							component: 'consumption_hierarchy',
							test_user: true,
						},
						{ title: 'pin_lock', component: 'pin_lock' },
						{ title: 'exclude_event_log', component: 'exclude_event_log' },
						{
							title: 'exclude_forgotten_lights',
							component: 'exclude_forgotten_lights',
							premium: true,
						},
					],
				},
				share,
				{
					title: 'settings',
					components: [
						{ title: 'eco_mode', component: 'eco_mode' },
						{ title: 'device_model', component: 'device_model' },
						{ title: 'power_on_default', component: 'power_on_default' },
						{ title: 'transition_time', component: 'transition_time' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{
							title: 'geo_location_and_time_zone',
							component: 'geo_location_and_time_zone',
						},
						{ title: 'device_name', component: 'device_name' },
						{ title: 'factory_reset', component: 'factory_reset_g1' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
		white: {
			channels: 1,
			notifications: ['offline', 'device_problem', 'forgotten_lights'],
			color_temp: { minValue: 3000, maxValue: 6500 },
			color: false,
			effects: false,
			slider: 'brightness',
			brightness: 0,
			settings: [
				timer,
				schedule,
				night_mode,
				actions,
				{
					title: 'networks',
					components: [
						{ title: 'wifi_mode_client', component: 'wifi_mode_client' },
						{ title: 'wifi_client_backup', component: 'wifi_client_backup' },
						{ title: 'wifi_mode_ap', component: 'wifi_mode_ap' },
						{ title: 'restrict_login', component: 'restrict_login' },
						{
							title: 'advanced_developer_settings',
							component: 'advanced_developer_settings',
						},
						{ title: 'cloud', component: 'cloud' },
					],
				},
				{
					title: 'application_settings',
					components: [
						{
							title: 'device_card_customization',
							component: 'customize_device_content',
						},
						{
							title: 'consumption_calculation',
							component: 'consumption_calculation',
						},
						{
							title: 'consumption_hierarchy',
							component: 'consumption_hierarchy',
							test_user: true,
						},
						{ title: 'pin_lock', component: 'pin_lock' },
						{ title: 'exclude_event_log', component: 'exclude_event_log' },
						{
							title: 'exclude_forgotten_lights',
							component: 'exclude_forgotten_lights',
							premium: true,
						},
					],
				},
				share,
				{
					title: 'settings',
					components: [
						{ title: 'eco_mode', component: 'eco_mode' },
						{ title: 'device_model', component: 'device_model' },
						{ title: 'power_on_default', component: 'power_on_default' },
						{ title: 'transition_time', component: 'transition_time' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{
							title: 'geo_location_and_time_zone',
							component: 'geo_location_and_time_zone',
						},
						{ title: 'device_name', component: 'device_name' },
						{ title: 'factory_reset', component: 'factory_reset_g1' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
